/* eslint-disable dot-notation */
import axios from 'axios';
import { useTokenStore } from '../store';

const devUrl = 'https://gamitar-be.herokuapp.com/api';
const prodUrl = 'https://gamitar-be.herokuapp.com/api'; // (hamza aco  unt link)

// const devUrl = 'https://gamitar-backend.herokuapp.com/api';
// const prodUrl = 'https://gamitar-backend.herokuapp.com/api';

// test

// const devUrl = 'http://localhost:4000/api';
// const prodUrl = 'http://localhost:4000/api';

export default function axiosClient() {
  const defaultOptions = {
    baseURL: process.env.NODE_ENV === 'production' ? prodUrl : devUrl,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    config.headers.Authorization = token;
    return config;
  });

  instance.defaults.headers.common['Authorization'] = useTokenStore.getState().accessToken;

  return instance;
}
